export abstract class ProvisionalDataService {
    abstract setProvisionalUser(firstName: string, lastName: string): void;
    abstract getProvisionalUser(): { firstName: string, lastName: string } | null;
}
